import React, {useEffect} from "react";
import style from './Login.scss';
import {useHistory} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import {Logo} from "@/components/atom/Logo";
import {ifLoginDo} from "@/util/authentication";
import {removeRedirect} from "@/util/redirection";

export const Top = () => {
  const history = useHistory()

  useEffect(() => {
    (async () => {
      removeRedirect()
      await ifLoginDo(() => {
        history.push(`/menu`)
      })
    })()
  }, [])

  const toLogin = () => {
    history.push('/login')
  }
  const toRegister = () => {
    history.push('/register/propose')
  }

  return (
    <div className="App">
      <RegisterLayout category={''}>
        <div className={style.loginTop}>
          <div className={style.contents}>
            <div>
              <div className={`${style.mainTitle} ${style.titleLogoBlock}`}>
                <Logo/>
              </div>
              <div onClick={toLogin} className={`${style.loginForm} ${style.already}`}>
                <div className={style.passwordInformation}>
                  <span className={style.topMenuButton}>利用登録がお済みの方はコチラ</span>
                </div>
              </div>
              <div onClick={toRegister} className={`${style.loginForm} ${style.yet}`}>
                <div className={style.passwordInformation}>
                  <span className={style.topMenuButton}>初めてのご利用登録はコチラ</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RegisterLayout>
    </div>
  )
}
